import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceKPILineDataDashboard } from '../services/getAssetPerformanceKPIData'

export interface flameKPIAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flameKPIAssetData: AssetPerformanceKPILineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flameKPIAssetDataState = {
  flameKPIAssetData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flameKPIGraphDataState = createSlice({
  name: 'flameKPIAssetDataState',
  initialState,
  reducers: {
    flameKPIGraphDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flameKPIAssetData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flameKPIGraphDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flameKPIAssetData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flameKPIGraphDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flameKPIAssetData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flameKPIGraphDataLoadingAction,
  flameKPIGraphDataUpdateAction,
  flameKPIGraphDataErrorAction
} = flameKPIGraphDataState.actions

export default flameKPIGraphDataState.reducer
